export default __webpack_public_path__ + "static/media/turtle-slow.70da7976.svg";